import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Check } from 'lucide-react';

// Mixins / Modules
import Window from '../../../../../../modules/window';

// Models
import User from '../../../../../../models/v2/user';

// Base
import Button from '../../../../base/button';
import Card from '../../../../base/card';

// Related Component
import Popup from './enterprise/popup';

export default class Enterprise extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    plan: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSetDuration: PropTypes.func.isRequired,
    onSubscribe: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      duration: props.duration,
      message: '',
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.duration !== nextState.duration) {
      return { duration: nextProps.duration};
    }
    return null;
  }

  get isSelected() {
    const { plan } = this.props;
    return plan === 'enterprise';
  }

  handleSkip = () => {
    this.setState({
      message: ''
    }, () => this.handleConfirm);
  }

  handleSetMessage = (_text, message) => {
    this.setState({ message });
  }

  handleConfirm = () => {
    const { user, duration, onSubscribe } = this.props;
    const { sending, message } = this.state;

    if (sending) return;

    this.setState({
      sending: true,
      isOpen: false,
    }, () => {
      const data = {
        id: user.id,
        plan_name: 'enterprise',
        plan_duration: duration,
        plan_message: message,
        plan_promo: '',
        send_plan_notification: true,
      };
      (new User(data))
        .save()
        .then((user) => {
          onSubscribe(user, 'confirm_call');
        })
        .catch((error) => {
          Window.flash.error(error);
          this.setState({ sending: false });
        })
    })
  }

  handleOpen = () => {
    const { onSelect } = this.props;
    this.setState({
      isOpen: true
    }, () => onSelect('enterprise'));
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  }

  render() {
    const { onSelect } = this.props;
    const { isOpen, sending, message } = this.state;

    return (
      <Card {...{
        className: classNames('enterprise standard-card width-380 height-625 relative padding-left-31', {
          selected: this.isSelected,
          hoverable: !this.isSelected,
        }),
        onClick: () => onSelect('enterprise'),
      }}>
        <div className='heading xlg-font semi-bold height-38 margin-top-40'>
          Enterprise
        </div>
        <div className='sub-heading xsm-font'>
          Custom Pricing
        </div>
        <div className='pricing-card-list'>
          <div className='height-52 flex margin-bottom-15'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              11+ Users, Large Team<br />
              Collaboration Tools
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Full Access to Entire Platform.
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Unlimited Private Contact Imports
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Access to Consultant Network6
            </div>
          </div>
          <div className='height-52 flex margin-bottom-15'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Unlimited Messaging &amp;<br />
              Campaigns
            </div>
          </div>
          <div className='height-52 flex margin-bottom-15'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              AI-Powered & Automated<br />
              Workflow Tools
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Dedicated Success Specialist
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Dedicated Resource Specialist
            </div>
          </div>
          <div className='absolute bottom-40 left-31 width-290'>
            <Button {...{
              text: 'CONTACT SALES',
              block: true,
              className: 'border-radius-4',
              size: 'xlg',
              onClick: () => this.handleOpen(),
              disabled: sending,
            }} />
          </div>
          <Popup {...{
            isOpen,
            message,
            onSetMessage: this.handleSetMessage,
            onSkip: this.handleSkip,
            onConfirm: this.handleConfirm,
            onCancel: this.handleClose,
          }} />
        </div>
      </Card>
    )
  }
}